import { Currency } from '@/core/currency/interfaces';

const JPY: Currency = {
    name: 'Japanese Yen',
    demonym: 'Japanese',
    majorSingle: 'Yen',
    majorPlural: 'Yen',
    codeNumeric: '392',
    symbol: '¥',
    symbolNative: '¥',
    minorSingle: 'Sen',
    minorPlural: 'Sen',
    ISOdigits: 0,
    decimals: 0,
    numToBasic: 100,
    code: 'JPY',
    delimiters: {
        thousands: ',',
        decimal: '.'
    }
};

export default JPY;
